/**
 * @generated SignedSource<<0bfe38a38bee270e9ec754ff8ce057f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSubMenu",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HeaderManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_platform"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavigationItem",
        "kind": "LinkedField",
        "name": "navigationItems",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_navigationItems"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Header_authenticationConfig"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HeaderManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableComplexMenu",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableSocialSharing",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoBackgroundColor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedLocales",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "centerMainMenu",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlatformLogos",
            "kind": "LinkedField",
            "name": "logos",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "header",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "legacyHeader",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useLocaleNamesInsteadOfFlags",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isViewer"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUser",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avatarUrl",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavigationItem",
        "kind": "LinkedField",
        "name": "navigationItems",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NavigationItem",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v0/*: any*/),
              (v1/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NavigationItem",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableUserAccounts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoRedirectSsoUrl",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "49a0663575640ea84addd9685d894fdb",
    "id": null,
    "metadata": {},
    "name": "HeaderManagerQuery",
    "operationKind": "query",
    "text": "query HeaderManagerQuery {\n  platform {\n    ...Header_platform\n    id\n  }\n  viewer {\n    __typename\n    ...Header_viewer\n    id\n  }\n  navigationItems {\n    ...Header_navigationItems\n    id\n  }\n  authenticationConfig {\n    ...Header_authenticationConfig\n    id\n  }\n}\n\nfragment ComplexMenuDesktopMainNavigation_navigationItems on NavigationItem {\n  id\n  ...ComplexMenuDesktopNavigationItem_navigationItem\n}\n\nfragment ComplexMenuDesktopMainNavigation_platform on Platform {\n  primaryColor\n  centerMainMenu\n}\n\nfragment ComplexMenuDesktopNavigationItem_navigationItem on NavigationItem {\n  id\n  name\n  url\n  iconClass\n  isSubMenu\n  children {\n    id\n    url\n  }\n  ...ComplexMenuDesktopVerticalSubmenu_navigationItem\n}\n\nfragment ComplexMenuDesktopVerticalSubmenuItem_navigationItem on NavigationItem {\n  id\n  name\n  url\n}\n\nfragment ComplexMenuDesktopVerticalSubmenu_navigationItem on NavigationItem {\n  children {\n    id\n    ...ComplexMenuDesktopVerticalSubmenuItem_navigationItem\n  }\n}\n\nfragment ComplexMenuMobileMainNavigation_navigationItems on NavigationItem {\n  id\n  children {\n    id\n    ...ComplexMenuMobileNavigationItem_navigationItem\n  }\n  ...ComplexMenuMobileNavigationItem_navigationItem\n}\n\nfragment ComplexMenuMobileMainNavigation_platform on Platform {\n  publishedLocales\n  primaryColor\n  ...LocaleSwitch_platform\n}\n\nfragment ComplexMenuMobileNavigationItem_navigationItem on NavigationItem {\n  id\n  name\n  url\n  iconClass\n  isSubMenu\n  children {\n    url\n    id\n  }\n}\n\nfragment HeaderAuthenticatedUser_authenticationConfig on AuthenticationConfig {\n  enableUserAccounts\n  autoRedirectSsoUrl\n}\n\nfragment HeaderAuthenticatedUser_viewer on Viewer {\n  __isViewer: __typename\n  isUser\n  name\n  ...UserAvatar_user\n}\n\nfragment HeaderWithComplexMenuDesktop_authenticationConfig on AuthenticationConfig {\n  enableUserAccounts\n  ...HeaderAuthenticatedUser_authenticationConfig\n}\n\nfragment HeaderWithComplexMenuDesktop_navigationItems on NavigationItem {\n  id\n  url\n  children {\n    url\n    id\n  }\n  ...ComplexMenuDesktopMainNavigation_navigationItems\n}\n\nfragment HeaderWithComplexMenuDesktop_platform on Platform {\n  id\n  title\n  subtitle\n  primaryColor\n  logoBackgroundColor\n  enableSocialSharing\n  publishedLocales\n  centerMainMenu\n  logos {\n    header\n  }\n  ...ComplexMenuDesktopMainNavigation_platform\n  ...LocaleSwitch_platform\n}\n\nfragment HeaderWithComplexMenuDesktop_viewer on Viewer {\n  __isViewer: __typename\n  ...HeaderAuthenticatedUser_viewer\n}\n\nfragment HeaderWithComplexMenuMobile_authenticationConfig on AuthenticationConfig {\n  enableUserAccounts\n  ...HeaderAuthenticatedUser_authenticationConfig\n}\n\nfragment HeaderWithComplexMenuMobile_navigationItems on NavigationItem {\n  id\n  url\n  children {\n    id\n    url\n  }\n  ...ComplexMenuMobileMainNavigation_navigationItems\n}\n\nfragment HeaderWithComplexMenuMobile_platform on Platform {\n  id\n  title\n  subtitle\n  primaryColor\n  logoBackgroundColor\n  enableSocialSharing\n  logos {\n    header\n  }\n  ...ComplexMenuMobileMainNavigation_platform\n}\n\nfragment HeaderWithComplexMenuMobile_viewer on Viewer {\n  __isViewer: __typename\n  ...HeaderAuthenticatedUser_viewer\n}\n\nfragment HeaderWithSimpleMenu_authenticationConfig on AuthenticationConfig {\n  ...SimpleMenuMainNavigation_authenticationConfig\n  ...HeaderAuthenticatedUser_authenticationConfig\n}\n\nfragment HeaderWithSimpleMenu_navigationItems on NavigationItem {\n  ...SimpleMenuMainNavigation_navigationItems\n}\n\nfragment HeaderWithSimpleMenu_platform on Platform {\n  id\n  title\n  subtitle\n  primaryColor\n  logoBackgroundColor\n  logos {\n    legacyHeader\n  }\n  ...SimpleMenuMainNavigation_platform\n}\n\nfragment HeaderWithSimpleMenu_viewer on Viewer {\n  __isViewer: __typename\n  ...SimpleMenuMainNavigation_viewer\n  ...HeaderAuthenticatedUser_viewer\n}\n\nfragment Header_authenticationConfig on AuthenticationConfig {\n  ...HeaderWithComplexMenuDesktop_authenticationConfig\n  ...HeaderWithComplexMenuMobile_authenticationConfig\n  ...HeaderWithSimpleMenu_authenticationConfig\n}\n\nfragment Header_navigationItems on NavigationItem {\n  ...HeaderWithComplexMenuDesktop_navigationItems\n  ...HeaderWithComplexMenuMobile_navigationItems\n  ...HeaderWithSimpleMenu_navigationItems\n}\n\nfragment Header_platform on Platform {\n  enableComplexMenu\n  enableSocialSharing\n  ...HeaderWithComplexMenuDesktop_platform\n  ...HeaderWithComplexMenuMobile_platform\n  ...HeaderWithSimpleMenu_platform\n}\n\nfragment Header_viewer on Viewer {\n  __isViewer: __typename\n  ...HeaderWithComplexMenuDesktop_viewer\n  ...HeaderWithComplexMenuMobile_viewer\n  ...HeaderWithSimpleMenu_viewer\n}\n\nfragment LocaleSwitch_platform on Platform {\n  publishedLocales\n  useLocaleNamesInsteadOfFlags\n}\n\nfragment SimpleMenuMainNavigation_authenticationConfig on AuthenticationConfig {\n  enableUserAccounts\n  ...HeaderAuthenticatedUser_authenticationConfig\n}\n\nfragment SimpleMenuMainNavigation_navigationItems on NavigationItem {\n  id\n  name\n  ...SimpleMenuNavigationItem_navigationItem\n  children {\n    id\n    ...SimpleMenuNavigationItem_navigationItem\n  }\n}\n\nfragment SimpleMenuMainNavigation_platform on Platform {\n  publishedLocales\n  primaryColor\n  ...LocaleSwitch_platform\n}\n\nfragment SimpleMenuMainNavigation_viewer on Viewer {\n  __isViewer: __typename\n  ...HeaderAuthenticatedUser_viewer\n}\n\nfragment SimpleMenuNavigationItem_navigationItem on NavigationItem {\n  isSubMenu\n  name\n  url\n  iconClass\n  children {\n    id\n    name\n    url\n    iconClass\n  }\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n"
  }
};
})();

node.hash = "e5ec53a8b88eefa8c2dec1e5ddbfc578";

module.exports = node;
